export default "__VITE_ASSET__ttbBYQCM__"